enum ReportTabEnum {
    Course = 1,
    People = 2    
}

export default ReportTabEnum